import { useHistory } from 'react-router-dom';
import userCourseHistoryApi from 'Api/axios/user-course-histories-api';
import useHistoryReportApi from 'Hooks/useHistoryReportApi';
import useTranslation from 'Hooks/useTranslation';
import { useState } from 'react';
import type { HistoryReportFilterI } from 'types';
import { downloadFile } from 'Utils/file-utils';

const useHistoryReportPage = () => {
  const history = useHistory();
  const { t2 } = useTranslation('history_reports');
  const [currentFilters, setCurrentFilters] = useState<HistoryReportFilterI>({});

  const {
    data: historyReportData,
    pagination: historyReportPagination,
    loading: historyReportLoading,
    error: historyReportError,
    fetchHistoryReport,
  } = useHistoryReportApi({ init: true });

  const handleSearch = (filters: HistoryReportFilterI) => {
    setCurrentFilters(filters);
    fetchHistoryReport({ ...filters, page: 1 });
  };

  const handlePageChange = (page: number) => {
    fetchHistoryReport({ ...currentFilters, page });
  };

  const handleRowsPerPageChange = (limit: number) => {
    setCurrentFilters(prev => ({ ...prev, limit }));
    fetchHistoryReport({ ...currentFilters, page: 1, limit });
  };

  const handleExport = async () => {
    const response = await userCourseHistoryApi.exportEmployeesCollection(currentFilters);

    if (response.data) {
      downloadFile(response.data, `historial_empleados_reporte.xlsx`);
    }
  };

  const handleRowClick = (row: { id: string }) => {
    history.push(`/reporte/historial/empleados/${row.id}`);
  };

  return {
    historyReportData,
    historyReportPagination,
    historyReportLoading,
    historyReportError,
    fetchHistoryReport,
    t2,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleExport,
    handleRowClick,
  };
};

export default useHistoryReportPage;
